import React from 'react';

const About = () => {
    return (
        <div className='mb-5 pb-5' style={{ height: '100vh' }}>
            <h2>About Us</h2>
            <p>   Learnfast is a self learning platform that offers various digital courses. Our mission is to prepare the next generation suitable enough to face modern challenges. Here our courses are designed with the help of experts and being continuously updated so that no one lags behind knowledge.</p>

            <p>
                Our curriculum includes- <br />
                * Live classes <br />
                * Timed tests <br />
                * Live feedback session <br />
                * Problem Discussion Chat room
            </p>
        </div>
    );
};

export default About;